// @ts-nocheck
import React from 'react';
import styles from './index.scss'

interface IDpDescriptionsProps {
  label?: React.ReactNode | string 
  title?: React.ReactNode | string 
  nodeName?: React.ReactNode | string 
  containerStyles?: React.CSSProperties
  style?: React.CSSProperties
  headerStyle?: React.CSSProperties
  nodeStyles?: React.CSSProperties
  [key: any]: any
  children: any
  
}

const Item = props => {
  const { children, label, colon = true } = props
  return (
    <div className={styles["dp-descriptions-item"]} style={props?.itemStyles} {...props?.itemProps}>
      {
        label && <div className={styles["dp-descriptions-item--label"]} style={props?.labelStyles}> {label}{colon ? '：' : undefined}</div>
      }
      <div className={styles["dp-descriptions-item--container"]} style={props?.contentStyles}>
        {children}
      </div>
    </div>
  )
}

const Header = props => {
  const { children } = props
  return <div className={styles["dp-descriptions-header"]} style={props?.headerStyle}> {children} </div>
}

const DpDescriptions = (props: IDpDescriptionsProps) => {
  const { children, title, nodeName } = props;
  return (
    <div className={styles["dp-descriptions"]} style={props?.style}>
      {title && <Header headerStyle={props?.headerStyle}>{title}</Header>}
      {nodeName && <div className={styles["dp-descriptions--node"]} style={props?.nodeStyles}> {nodeName}</div>}
      <div className={styles["dp-descriptions--container"]} style={props?.containerStyles}>
        {children}
      </div>
    </div>
  )
};

DpDescriptions.Header = Header
DpDescriptions.Item = Item
export default DpDescriptions;
